<template>
  <div class="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
    <div class="max-w-md w-full text-center space-y-8">
      <div class="flex justify-center">
        <img src="@/assets/logo/logo_horizntal.png" alt="Ruxzom" class="h-16" />
      </div>
      
      <div class="bg-white p-8 rounded-2xl shadow-xl space-y-6 border border-gray-100">
        <div class="w-20 h-20 bg-primary-50 rounded-full flex items-center justify-center mx-auto">
          <svg class="w-10 h-10 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </div>
        
        <div class="space-y-2">
          <h1 class="text-2xl font-bold text-gray-900 font-heading">Under Maintenance</h1>
          <p class="text-gray-600">
            We are currently performing scheduled maintenance to improve our services. 
            We'll be back online shortly.
          </p>
        </div>

        <div class="pt-4">
          <p class="text-sm text-gray-500">
            Need urgent assistance? 
            <a href="mailto:support@ruxzom.com" class="text-primary-600 font-medium hover:underline">Contact Support</a>
          </p>
        </div>
      </div>
      
      <p class="text-sm text-gray-400">
        &copy; {{ new Date().getFullYear() }} {{ settingsStore.settings.company_name || 'Ruxzom' }}. All rights reserved.
      </p>
    </div>
  </div>
</template>

<script setup>
import { useSettingsStore } from '@/stores/settings'
const settingsStore = useSettingsStore()
</script>
